/**
 * API Configuration
 *
 * Single source of truth for API base URL and common API utilities.
 * All services and stores should import from here instead of
 * duplicating `import.meta.env.VITE_API_URL || 'http://localhost:3002'`.
 */

/**
 * Get the API base URL from environment or default.
 * Used for both HTTP requests and Socket.IO connections.
 */
export function getApiUrl(): string {
  return import.meta.env.VITE_API_URL || 'http://localhost:3002';
}
